import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=2978e8eb&scoped=true&"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=2978e8eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2978e8eb",
  null
  
)

export default component.exports